import { isValidPrice } from '@domain-group/javascript-utils'

const state = {
  agency_id: null,
  campaign_id: null,
  id: null,
  invoice_date: '',
  invoice_notes: '',
  invoice_reference: '',
  invoice_total: undefined,
  data: {
    unapprove_reason: '',
  },
  order_type: '',
  override_reason: '',
  paid_by: '',
  provider_id: null,
  shipping_address: '',
  title: '',
  total_override: null,
  total: null,
  user_id: null,
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'order_type' },
  { key: 'provider_id' },
  { key: 'title' },
  { key: 'total', validation: isValidPrice, invalidMessage: 'Invalid Price' },
  { key: 'user_id' },
]

export default state
